import { Button } from "../Button";
import React, { useEffect, useMemo, useState } from "react";
import { createMailtoLink, createWhatsappQuotationLink } from "../../service/quotation.mjs";
import { formatCurrency } from "../../helpers/number";
import { clearCart } from "../../states/cart.mjs";
import { useNavigate } from "react-router-dom";

export function QuotationOptions({ shipping, carts, amount }) {
  const [mailToSubject, setMailToSubject] = useState("");
  const [mailToBody, setMailToBody] = useState("");
  const navigate = useNavigate();

  const onConfirm = useMemo(() => {
    return (mode = "email") => {
      const subject = `Quotation for ${shipping?.fullname ?? ""} from Haier website`;
      const body = `
PERSONAL INFO
-----------------------
Fullname : ${shipping?.fullname}\n
Mobile : ${shipping?.mobile}\n
Email: ${shipping?.email}\n
Region: ${shipping?.region}\n

PRODUCTS
------------------------

${carts.map((x, index) => `${index + 1}. ${x?.product?.name ?? x?.product?.product} ,  ${x?.quantity} @ TZS ${formatCurrency(x?.product?.retailPrice)} = TZS ${formatCurrency(x?.product?.retailPrice * x?.quantity)}`).join("\n")}

------------------------
TOTAL : TZS ${formatCurrency(amount)}
                `;
      setMailToSubject(subject);
      setMailToBody(body);
      // setShowModal(false);
      if (mode === "email") {
        // document.getElementById('mail_quotation').click();
        const link = document.createElement("a");
        link.target = "_blank";
        link.href = createMailtoLink(subject, body);
        link.id = "mail_quotation";
        // clearCart();
        link.click();
        // try {
        //   document.removeChild(link);
        // } catch (e) {
        // }
      } else if (mode === "whatsapp") {
        const link = document.createElement("a");
        link.target = "_blank";
        link.href = createWhatsappQuotationLink(subject, body);
        link.id = "whatsapp_quotation";
        // clearCart();
        link.click();
        // document.removeChild(link);
        // try {
        //   document.removeChild(link);
        // } catch (e) {
        // }
      }
    };
  }, [amount, carts, shipping]);

  return (
    <>
      <div
        className="bg-white-A700 flex md:flex-1 flex-col border items-start justify-start p-2.5 rounded-lg w-[67%] md:w-full">
        {/*<div className="w-[80px] h-auto cursor-pointer">*/}
        {/*  <Img alt="Tigopesa" className="object-cover" src="/images/tigopesa.png" />*/}
        {/*</div>*/}
        {/*<FormInput*/}
        {/*  value={formData?.mobile}*/}
        {/*  onChange={(value) => {*/}
        {/*    setFormData(p => ({ ...p, mobile: value }));*/}
        {/*    setErrors(p => ({ ...p, mobile: [] }));*/}
        {/*  }}*/}
        {/*  errors={errors?.mobile}*/}
        {/*  type={"number"}*/}
        {/*  className="flex flex-col gap-[7px] items-start justify-start mt-6 w-full"*/}
        {/*  placeholder="Enter number"*/}
        {/*  label="Tigo-pesa mobile number for payment"*/}
        {/*/>*/}
        {/*<Button*/}
        {/*  onClick={validateFormData}*/}
        {/*  className="cursor-pointer flex items-center justify-center mb-9 min-w-[178px] mt-4 rounded-[20px]"*/}
        {/*  leftIcon={*/}
        {/*    <Img*/}
        {/*      className="mr-[13px]"*/}
        {/*      src="images/img_payment_white_a700.svg"*/}
        {/*      alt="Payment"*/}
        {/*    />*/}
        {/*  }*/}
        {/*  shape="circle"*/}
        {/*  color="indigo_A700"*/}
        {/*  size="xs"*/}
        {/*  variant="fill"*/}
        {/*>*/}
        {/*  <div className="!text-white-A700 text-left text-sm tracking-[0.25px]">*/}
        {/*    PAY*/}
        {/*  </div>*/}
        {/*</Button>*/}
        <div className={"flex-row flex-wrap flex"}>
          <Button onClick={() => onConfirm("email")}
                  className="cursor-pointer flex items-center h-[48px] justify-center mb-2 min-w-[178px] mt-2 rounded-[8px]"
                  shape="circle"
                  color="orange_A200"
                  size="xs"
                  variant="fill"
          >
            ORDER BY EMAIL
          </Button>
          <div style={{ display: "inline", margin: 5 }} />
          <Button onClick={() => onConfirm("whatsapp")}
                  className="cursor-pointer px-4 h-[48px] flex items-center justify-center mb-2 min-w-[178px] mt-2 rounded-[8px]"
                  shape="circle"
                  style={{backgroundColor:'#8eec00'}}
                  size="xs"
                  variant="fill"
          >
            ORDER BY WHATSAPP
          </Button>
        </div>
        <Button onClick={() => {
          clearCart();
          navigate("/productspage");
        }}
                className="cursor-pointer h-[48px] flex items-center justify-center mb-2 min-w-[178px] mt-2 rounded-[8px]"
                shape="circle"
                size="xs"
                style={{ backgroundColor: "rgb(205,205,205)" }}
                variant="fill"
        >
          DONE / CLOSE
        </Button>
        {/*<>*/}
        {/*  */}
        {/*  <div style={{ display: "block", margin: "16px 0" }} />*/}
        {/*</>*/}
      </div>
      <a target={"_blank"} id={"mail_quotation"}
         href={createMailtoLink(mailToSubject, mailToBody)} />
    </>
  );
}